// The query string is user-controlled. Accept only an international phone made
// of digits before using it in a Firestore lookup.
export const whatsappDeepLinkPhone = (search: string): string => {
  const raw = new URLSearchParams(search).get("phone") || "";
  return /^\d{10,15}$/.test(raw) ? raw : "";
};
